import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
const stats = [{
  label: 'Inferences Processed',
  value: 500,
  suffix: 'B+'
}, {
  label: 'Global Developers',
  value: 50,
  suffix: 'K+'
}, {
  label: 'FPGA Providers',
  value: 12,
  suffix: '+'
}, {
  label: 'Accelerator Configs',
  value: 80,
  suffix: '+'
}];
export function StatsBar() {
  return <div className="w-full bg-gate-surface/30 border-y border-gate-border/50 py-12" data-id="element-269">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-270">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center" data-id="element-271">
          {stats.map((stat, index) => <StatItem key={index} stat={stat} index={index} data-id="element-272" />)}
        </div>
      </div>
    </div>;
}
function StatItem({
  stat,
  index
}: {
  stat: (typeof stats)[0];
  index: number;
}) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    const duration = 2000;
    const steps = 60;
    const stepTime = duration / steps;
    const increment = stat.value / steps;
    let current = 0;
    const timer = setInterval(() => {
      current += increment;
      if (current >= stat.value) {
        setCount(stat.value);
        clearInterval(timer);
      } else {
        setCount(Math.floor(current));
      }
    }, stepTime);
    return () => clearInterval(timer);
  }, [stat.value]);
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    delay: index * 0.1,
    duration: 0.5
  }} className="flex flex-col items-center" data-id="element-273">
      <div className="text-3xl sm:text-4xl font-bold font-mono text-white mb-2" data-id="element-274">
        {count}
        {stat.suffix}
      </div>
      <div className="text-sm text-gate-text-secondary font-medium uppercase tracking-wider" data-id="element-275">
        {stat.label}
      </div>
    </motion.div>;
}